// extracted by mini-css-extract-plugin
export default {"formBody":"AssignTrialModal_formBody__zvcw2"};